import { render } from "./PolicyDetailModal.vue?vue&type=template&id=31dc5aff&scoped=true"
import script from "./PolicyDetailModal.vue?vue&type=script&lang=js"
export * from "./PolicyDetailModal.vue?vue&type=script&lang=js"

import "./PolicyDetailModal.vue?vue&type=style&index=0&id=31dc5aff&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31dc5aff"]])

export default __exports__